import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col space-y-4"
}
const _hoisted_2 = { class: "px-3 py-2 rounded-lg bg-[#1f2937] border border-[#374151]" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-300" }, "Trajet", -1)
const _hoisted_4 = { class: "text-base font-semibold text-accent" }
const _hoisted_5 = {
  key: 0,
  class: "text-xs text-gray-400"
}
const _hoisted_6 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4" }
const _hoisted_7 = { class: "flex flex-col p-3 rounded-lg border border-[#374151]" }
const _hoisted_8 = { class: "text-sm font-semibold text-gray-300 mb-2" }
const _hoisted_9 = {
  key: 0,
  class: "text-xs text-gray-500 italic"
}
const _hoisted_10 = {
  key: 1,
  class: "text-xs text-gray-500 italic"
}
const _hoisted_11 = {
  key: 2,
  class: "flex flex-col space-y-1 max-h-[280px] overflow-y-auto custumScroll"
}
const _hoisted_12 = { class: "flex flex-row items-center space-x-2 min-w-0" }
const _hoisted_13 = { class: "text-[10px] px-1.5 py-0.5 rounded bg-blue-700 text-white font-mono" }
const _hoisted_14 = { class: "truncate text-sm text-gray-200" }
const _hoisted_15 = {
  key: 0,
  class: "text-[10px] text-yellow-400"
}
const _hoisted_16 = { class: "flex flex-row items-center space-x-1" }
const _hoisted_17 = ["disabled", "onClick"]
const _hoisted_18 = ["disabled", "onClick"]
const _hoisted_19 = ["disabled", "onClick"]
const _hoisted_20 = { class: "flex flex-col space-y-2 mt-3 pt-3 border-t border-[#374151]" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400" }, "Ajouter un arrêt depuis le référentiel", -1)
const _hoisted_22 = {
  key: 0,
  class: "flex flex-col space-y-1"
}
const _hoisted_23 = { class: "text-[10px] text-gray-500" }
const _hoisted_24 = { class: "flex flex-row flex-wrap gap-1" }
const _hoisted_25 = ["disabled", "title", "onClick"]
const _hoisted_26 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_27 = { class: "flex flex-col space-y-1" }
const _hoisted_28 = {
  key: 0,
  class: "flex flex-col space-y-1 max-h-[120px] overflow-y-auto custumScroll border border-[#1e293b] rounded p-1"
}
const _hoisted_29 = ["disabled", "onClick"]
const _hoisted_30 = { class: "truncate text-gray-200" }
const _hoisted_31 = { class: "text-gray-500 ml-1 text-[10px]" }
const _hoisted_32 = {
  key: 0,
  class: "text-green-400 text-[10px]"
}
const _hoisted_33 = {
  key: 1,
  class: "text-[10px] text-gray-500 italic"
}
const _hoisted_34 = {
  key: 1,
  class: "flex flex-col space-y-2 pt-2 border-t border-[#1e293b]"
}
const _hoisted_35 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_36 = { class: "flex items-center space-x-2 text-xs text-gray-300" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "Marquer comme terminus (origine ou arrivée finale)", -1)
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "flex flex-col p-3 rounded-lg border border-[#374151]" }
const _hoisted_40 = { class: "text-sm font-semibold text-gray-300 mb-2" }
const _hoisted_41 = {
  key: 0,
  class: "text-xs text-gray-500 italic"
}
const _hoisted_42 = {
  key: 1,
  class: "text-xs text-gray-500 italic"
}
const _hoisted_43 = {
  key: 2,
  class: "flex flex-col space-y-1 max-h-[280px] overflow-y-auto custumScroll"
}
const _hoisted_44 = { class: "flex flex-col min-w-0 flex-1" }
const _hoisted_45 = { class: "text-gray-200 truncate" }
const _hoisted_46 = { class: "text-xs text-yellow-300 font-semibold" }
const _hoisted_47 = ["disabled", "onClick"]
const _hoisted_48 = { class: "flex flex-col space-y-2 mt-3 pt-3 border-t border-[#374151]" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400" }, "Nouveau tarif segmenté", -1)
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  key: 1,
  class: "text-gray-400 text-sm py-10 text-center"
}
const _hoisted_52 = { class: "flex flex-row items-end justify-end w-full" }

import { computed, ref, watch } from "vue";
	import api from "@/api";
	import useNotyf from "@/composable/useNotyf";
	import useFormatMoney from "@/composable/useFormatMoney";
	import { useConfirm } from "@/composable/useConfirm";
	import { currentStation } from "@/state/api/userState";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'TravelRouteStopsModal',
  props: {
    open: { type: Boolean },
    route: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

	/**
	 * Modale d'édition des arrêts intermédiaires + tarifs segmentés d'un
	 * trajet (P2). Ouverte depuis RoutesAndRatesPlanning.vue via le
	 * dot_action « Configurer les arrêts ».
	 *
	 * 2 sections empilées :
	 *   1. Liste ordonnée des arrêts (CRUD + reorder)
	 *   2. Matrice des tarifs segmentés (couple from→to → cost)
	 *
	 * API consommée : api.routes.stops.* et api.routes.rateSegments.* (P1).
	 * Fail-safe : un trajet sans stops conserve son comportement actuel
	 * (TicketRate global). Le caissier peut continuer à enregistrer des
	 * passagers même si l'admin n'a pas configuré les stops.
	 */
	const notify = useNotyf();
	const { confirm } = useConfirm();

	const props = __props;

	const emit = __emit;

	// ────────────────────────────────────────────────────────────────
	// État local
	// ────────────────────────────────────────────────────────────────
	const stops = ref<any[]>([]);
	const segments = ref<any[]>([]);
	const isLoadingStops = ref(false);
	const isLoadingSegments = ref(false);
	const isSaving = ref(false);

	// P8 — Gazetteer cities pour la sélection des arrêts.
	// suggestedCities = arrêts intermédiaires proposés par le backend
	// (heuristique corridor entre from_city et to_city du travel_route).
	// allCities = liste complète du pays (fallback recherche libre).
	const suggestedCities = ref<any[]>([]);
	const allCities = ref<any[]>([]);
	const cityPickerSearch = ref("");
	const isLoadingCities = ref(false);
	const showManualForm = ref(false);

	// Form pour ajouter un nouveau stop (mode manuel — fallback root).
	const newStopForm = ref({
		label: "",
		latitude: null as number | null,
		longitude: null as number | null,
		estimated_minutes_from_origin: null as number | null,
		is_terminus: false,
	});

	// Form pour ajouter un nouveau segment tarifaire.
	const newSegmentForm = ref({
		from_stop_id: null as number | null,
		to_stop_id: null as number | null,
		cost: null as number | null,
	});

	// ────────────────────────────────────────────────────────────────
	// Computed
	// ────────────────────────────────────────────────────────────────
	const sortedStops = computed(() =>
		[...stops.value].sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0)),
	);

	const stopOptions = computed(() =>
		sortedStops.value.map((s) => ({
			key: s.id,
			value: `#${s.sequence} · ${s.display_label || s.label || "Stop"}`,
		})),
	);

	// Pour l'affichage matriciel des tarifs.
	const segmentsByCouple = computed<Record<string, any>>(() => {
		const map: Record<string, any> = {};
		for (const s of segments.value) {
			map[`${s.from_stop_id}-${s.to_stop_id}`] = s;
		}
		return map;
	});

	// ────────────────────────────────────────────────────────────────
	// Loaders
	// ────────────────────────────────────────────────────────────────
	async function loadStops() {
		if (!props.route?.uuid) return;
		isLoadingStops.value = true;
		try {
			const res: any = await api().routes.stops.list(props.route.uuid);
			stops.value = Array.isArray(res.data) ? res.data : res.data?.data || [];
			// Matérialise from_city / to_city comme stops si absents (sans ça,
			// le dropdown "Arrêt de départ" ne peut pas proposer la ville
			// d'origine du trajet — donc l'agence vendant depuis Yaoundé ne
			// peut pas créer de segment "Yaoundé → Bafia"). Idempotent.
			const created = await ensureTerminusStops();
			if (created) {
				const res2: any = await api().routes.stops.list(props.route.uuid);
				stops.value = Array.isArray(res2.data) ? res2.data : res2.data?.data || [];
			}
			// Pré-sélection : l'arrêt de départ du segment tarifaire est par
			// défaut celui qui correspond à la city de la station (agence)
			// courante. L'utilisateur peut le changer manuellement, mais
			// pour un agent qui vend depuis son agence, c'est le cas 90 %.
			applyDefaultFromStop();
		} catch (err: any) {
			// callApi rejette avec error.response directement. Le sanitizer
			// attend `input.response?.data` — on rewrappe pour que les
			// messages 422 (validation Laravel) s'affichent proprement.
			notify.error({ response: err });
		}
		isLoadingStops.value = false;
	}

	async function ensureTerminusStops(): Promise<boolean> {
		// Si le trajet a from_city / to_city dans le gazetteer mais qu'aucun
		// stop ne les référence, on les crée comme terminus pour qu'ils
		// apparaissent dans les pickers des tarifs segmentés. Sans ça, l'agence
		// vendant depuis Yaoundé ne peut pas créer le segment "Yaoundé → Bafia".
		// Le backend a sequence min:1 + décalage auto sur collision : on insère
		// from_city en seq=1 (pousse les intermédiaires) et to_city à max+1.
		const route: any = props.route;
		if (!route) return false;
		const fromCityId = route.from_city_id ?? route.from_city?.id ?? null;
		const toCityId = route.to_city_id ?? route.to_city?.id ?? null;
		const existingCityIds = new Set(stops.value.map((s: any) => s.city_id).filter(Boolean));
		let created = false;
		try {
			if (fromCityId && !existingCityIds.has(fromCityId)) {
				await api().routes.stops.create(route.uuid, {
					travel_route_id: route.id,
					sequence: 1,
					city_id: fromCityId,
					is_terminus: true,
				});
				created = true;
			}
			if (toCityId && !existingCityIds.has(toCityId)) {
				// Recalcule le max après création éventuelle de from_city
				// (qui a poussé les autres de +1). On vise la fin du trajet.
				const maxSeq = created
					? stops.value.length + 1
					: stops.value.reduce(
						(m: number, s: any) => Math.max(m, s.sequence ?? 0),
						0,
					);
				await api().routes.stops.create(route.uuid, {
					travel_route_id: route.id,
					sequence: maxSeq + 1,
					city_id: toCityId,
					is_terminus: true,
				});
				created = true;
			}
		} catch (err: any) {
			// Création best-effort : si le backend rejette (FK, sequence en
			// collision, droits insuffisants), on laisse l'utilisateur
			// gérer manuellement plutôt que de bloquer l'ouverture du modal.
			console.warn("[ensureTerminusStops] échec auto-create terminus", err);
		}
		return created;
	}

	function applyDefaultFromStop() {
		// Pas d'écrasement si l'utilisateur a déjà choisi.
		if (newSegmentForm.value.from_stop_id) return;
		const stationCityId =
			currentStation.value?.city?.id ?? currentStation.value?.city_id ?? null;
		if (!stationCityId) return;
		const match = stops.value.find((s: any) => s.city_id === stationCityId);
		if (match) {
			newSegmentForm.value.from_stop_id = match.id;
		}
	}

	async function loadSegments() {
		if (!props.route?.uuid) return;
		isLoadingSegments.value = true;
		try {
			const res: any = await api().routes.rateSegments.list(props.route.uuid);
			segments.value = Array.isArray(res.data) ? res.data : res.data?.data || [];
		} catch (err: any) {
			// callApi rejette avec error.response directement. Le sanitizer
			// attend `input.response?.data` — on rewrappe pour que les
			// messages 422 (validation Laravel) s'affichent proprement.
			notify.error({ response: err });
		}
		isLoadingSegments.value = false;
	}

	// P8 — Charge les villes : intermédiaires proposés (si le trajet a
	// from_city + to_city) + liste full pays (pour recherche libre).
	async function loadCities() {
		isLoadingCities.value = true;
		try {
			// Suggestions corridor entre from_city et to_city.
			const fromUuid = props.route?.from_city?.uuid;
			const toUuid = props.route?.to_city?.uuid;
			if (fromUuid && toUuid) {
				const res: any = await api().cities.intermediatesBetween(fromUuid, toUuid);
				suggestedCities.value = Array.isArray(res.data) ? res.data : res.data?.data || [];
			} else {
				suggestedCities.value = [];
			}
			// Liste full du pays pour recherche libre (fallback).
			const countryId = props.route?.country_id ?? props.route?.from_city?.country_id;
			const res2: any = await api().cities.all(countryId);
			allCities.value = Array.isArray(res2.data) ? res2.data : res2.data?.data || [];
		} catch (err: any) {
			notify.error({ response: err });
		}
		isLoadingCities.value = false;
	}

	// Recharge quand la modale s'ouvre OU quand le trajet change.
	watch(
		() => [props.open, props.route?.uuid],
		([isOpen, uuid]) => {
			if (isOpen && uuid) {
				loadStops();
				loadSegments();
				loadCities();
			}
		},
		{ immediate: true },
	);

	// IDs des cities déjà utilisées comme stop, pour griser dans le picker.
	const usedCityIds = computed(() => new Set(stops.value.map((s) => s.city_id).filter(Boolean)));

	// Liste filtrée selon la recherche pour le picker libre.
	const filteredCities = computed(() => {
		const term = cityPickerSearch.value.trim().toLowerCase();
		if (!term) return allCities.value.slice(0, 30); // limite l'affichage initial
		return allCities.value.filter((c: any) =>
			(c.label || "").toLowerCase().includes(term)
			|| (c.region || "").toLowerCase().includes(term)
		).slice(0, 50);
	});

	// ────────────────────────────────────────────────────────────────
	// CRUD stops
	// ────────────────────────────────────────────────────────────────

	/**
	 * P8 — Ajoute un stop à partir d'une city du gazetteer.
	 * Backend auto-remplit label/lat/lng depuis la city (source de vérité).
	 * L'admin enterprise n'a pas à saisir de coords.
	 */
	async function addStopFromCity(city: any, options: { isTerminus?: boolean } = {}) {
		if (!props.route?.uuid) {
			notify.error("Trajet non sélectionné (route.uuid manquant)");
			return;
		}
		if (!city?.id) {
			notify.warning("Ville invalide");
			return;
		}
		if (usedCityIds.value.has(city.id)) {
			notify.warning(`${city.label} est déjà dans le trajet`);
			return;
		}
		isSaving.value = true;
		try {
			const nextSeq =
				sortedStops.value.length > 0
					? (sortedStops.value[sortedStops.value.length - 1].sequence ?? 0) + 1
					: 1;
			await api().routes.stops.create(props.route.uuid, {
				travel_route_id: props.route.id,
				sequence: nextSeq,
				city_id: city.id,
				// label/latitude/longitude écrasés côté backend depuis la city.
				is_terminus: !!options.isTerminus,
			});
			notify.success(`Arrêt « ${city.label} » ajouté`);
			cityPickerSearch.value = "";
			await loadStops();
		} catch (err: any) {
			notify.error({ response: err });
		}
		isSaving.value = false;
	}

	async function addStop() {
		if (!props.route?.uuid) {
			notify.error("Trajet non sélectionné (route.uuid manquant)");
			return;
		}
		const f = newStopForm.value;
		if (!f.label || !f.label.trim()) {
			notify.warning("Libellé requis");
			return;
		}
		// Validation locale lat/lng : le backend rejette en 422 mais le
		// message est noyé dans `data` — autant arrêter avant la requête
		// et donner une raison claire à l'opérateur.
		if (f.latitude != null && (f.latitude < -90 || f.latitude > 90)) {
			notify.warning("Latitude invalide (doit être entre -90 et 90)");
			return;
		}
		if (f.longitude != null && (f.longitude < -180 || f.longitude > 180)) {
			notify.warning("Longitude invalide (doit être entre -180 et 180)");
			return;
		}
		isSaving.value = true;
		try {
			// La sequence par défaut = max+1 (insertion à la fin).
			const nextSeq =
				sortedStops.value.length > 0
					? (sortedStops.value[sortedStops.value.length - 1].sequence ?? 0) + 1
					: 1;
			await api().routes.stops.create(props.route.uuid, {
				travel_route_id: props.route.id,
				sequence: nextSeq,
				label: f.label.trim(),
				latitude: f.latitude,
				longitude: f.longitude,
				estimated_minutes_from_origin: f.estimated_minutes_from_origin,
				is_terminus: !!f.is_terminus,
			});
			notify.success("Arrêt ajouté");
			newStopForm.value = {
				label: "",
				latitude: null,
				longitude: null,
				estimated_minutes_from_origin: null,
				is_terminus: false,
			};
			await loadStops();
		} catch (err: any) {
			// callApi rejette avec error.response directement (pas error).
			// On normalise pour que sanitizeErrorMessage trouve bien
			// data.errors[champ][0] (format Laravel 422).
			notify.error({ response: err });
		}
		isSaving.value = false;
	}

	async function removeStop(stop: any) {
		// Defense : si stop ou stop.uuid manque, le DELETE part sur
		// /stops/undefined → 404 silencieux côté UX. On bloque tôt.
		if (!stop || !stop.uuid) {
			console.warn("[removeStop] stop.uuid manquant", stop);
			notify.warning("Impossible de supprimer cet arrêt (UUID manquant). Rechargez la modale.");
			return;
		}
		const stopName = stop.display_label || stop.label || "Sans nom";
		const ok = await confirm({
			title: "Supprimer l'arrêt",
			message: `Voulez-vous vraiment retirer « ${stopName} » de ce trajet ?`,
			details: [
				"Les tarifs segmentés référençant cet arrêt seront aussi supprimés.",
			],
			confirmLabel: "Supprimer",
			cancelLabel: "Annuler",
			tone: "danger",
		});
		if (!ok) return;
		isSaving.value = true;
		try {
			await api().routes.stops.remove(stop.uuid);
			notify.success(`Arrêt « ${stopName} » supprimé`);
			await loadStops();
			await loadSegments(); // Les segments référençant ce stop peuvent avoir cascadé.
		} catch (err: any) {
			// callApi rejette avec error.response directement. Le sanitizer
			// attend `input.response?.data` — on rewrappe pour que les
			// messages 422 (validation Laravel) s'affichent proprement.
			console.error("[removeStop] échec suppression", { stop, err });
			notify.error({ response: err });
		} finally {
			// finally : garantit que le bouton se rédisabilise même si une
			// exception non-axios remonte (sinon `isSaving` reste true et
			// tous les boutons de la modale restent figés en disabled).
			isSaving.value = false;
		}
	}

	async function moveStop(stop: any, direction: -1 | 1) {
		// Échange sequence avec le voisin. Le backend gère le décalage atomique
		// via reorder, on lui envoie la nouvelle séquence complète.
		const arr = [...sortedStops.value];
		const idx = arr.findIndex((s) => s.id === stop.id);
		const target = idx + direction;
		if (target < 0 || target >= arr.length) return;
		[arr[idx], arr[target]] = [arr[target], arr[idx]];
		const uuids = arr.map((s) => s.uuid);
		isSaving.value = true;
		try {
			await api().routes.stops.reorder(props.route.uuid, uuids);
			await loadStops();
		} catch (err: any) {
			// callApi rejette avec error.response directement. Le sanitizer
			// attend `input.response?.data` — on rewrappe pour que les
			// messages 422 (validation Laravel) s'affichent proprement.
			notify.error({ response: err });
		}
		isSaving.value = false;
	}

	// ────────────────────────────────────────────────────────────────
	// CRUD segments
	// ────────────────────────────────────────────────────────────────
	async function addSegment() {
		const f = newSegmentForm.value;
		if (!f.from_stop_id || !f.to_stop_id || f.cost == null) {
			notify.warning("Renseignez départ, arrivée et tarif");
			return;
		}
		if (f.from_stop_id === f.to_stop_id) {
			notify.warning("Départ et arrivée doivent être différents");
			return;
		}
		isSaving.value = true;
		try {
			await api().routes.rateSegments.create(props.route.uuid, {
				travel_route_id: props.route.id,
				from_stop_id: f.from_stop_id,
				to_stop_id: f.to_stop_id,
				cost: f.cost,
			});
			notify.success("Tarif segmenté ajouté");
			newSegmentForm.value = { from_stop_id: null, to_stop_id: null, cost: null };
			applyDefaultFromStop();
			await loadSegments();
		} catch (err: any) {
			// callApi rejette avec error.response directement. Le sanitizer
			// attend `input.response?.data` — on rewrappe pour que les
			// messages 422 (validation Laravel) s'affichent proprement.
			notify.error({ response: err });
		}
		isSaving.value = false;
	}

	async function removeSegment(segment: any) {
		isSaving.value = true;
		try {
			await api().routes.rateSegments.remove(segment.uuid);
			notify.success("Tarif retiré");
			await loadSegments();
		} catch (err: any) {
			// callApi rejette avec error.response directement. Le sanitizer
			// attend `input.response?.data` — on rewrappe pour que les
			// messages 422 (validation Laravel) s'affichent proprement.
			notify.error({ response: err });
		}
		isSaving.value = false;
	}

	function getStopLabel(stopId: number): string {
		const s = stops.value.find((x) => x.id === stopId);
		return s ? `#${s.sequence} · ${s.display_label || s.label || "Stop"}` : `Stop #${stopId}`;
	}

return (_ctx: any,_cache: any) => {
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_ButtonTag = _resolveComponent("ButtonTag")!
  const _component_ModalPage = _resolveComponent("ModalPage")!

  return (_ctx.open)
    ? (_openBlock(), _createBlock(_component_ModalPage, {
        key: 0,
        title: "Configuration du trajet : arrêts + tarifs segmentés",
        name: "TravelRouteStopsModal",
        styleContent: "w-full",
        styleFooter: "w-full",
        styleModal: '!w-3/4',
        onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('close')))
      }, {
        content: _withCtx(() => [
          (_ctx.route)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.route.label || `Trajet #${_ctx.route.id}`), 1),
                  (_ctx.route.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.route.description), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, " Arrêts ordonnés (" + _toDisplayString(sortedStops.value.length) + ") ", 1),
                    (isLoadingStops.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Chargement…"))
                      : (sortedStops.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Aucun arrêt configuré. Si vide, ce trajet conserve le comportement actuel (vente du guichet d'origine au terminus implicite). "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedStops.value, (stop, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: stop.uuid,
                                class: "flex flex-row items-center justify-between px-2 py-1 rounded bg-[#0f172a] border border-[#1e293b]"
                              }, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("span", _hoisted_13, " #" + _toDisplayString(stop.sequence), 1),
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(stop.display_label || stop.label || "Sans nom"), 1),
                                  (stop.is_terminus)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "terminus"))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "text-sm text-gray-400 hover:text-white disabled:opacity-30 px-2 py-1 rounded hover:bg-[#1e293b]",
                                    disabled: i === 0 || isSaving.value,
                                    onClick: ($event: any) => (moveStop(stop, -1)),
                                    title: "Monter"
                                  }, " ↑ ", 8, _hoisted_17),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "text-sm text-gray-400 hover:text-white disabled:opacity-30 px-2 py-1 rounded hover:bg-[#1e293b]",
                                    disabled: i === sortedStops.value.length - 1 || isSaving.value,
                                    onClick: ($event: any) => (moveStop(stop, 1)),
                                    title: "Descendre"
                                  }, " ↓ ", 8, _hoisted_18),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "text-base text-red-400 hover:text-white hover:bg-red-600 disabled:opacity-30 ml-1 px-2 py-1 rounded font-bold leading-none",
                                    disabled: isSaving.value,
                                    onClick: ($event: any) => (removeStop(stop)),
                                    title: "Supprimer cet arrêt"
                                  }, " × ", 8, _hoisted_19)
                                ])
                              ]))
                            }), 128))
                          ])),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      (suggestedCities.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("p", _hoisted_23, " Suggérés sur ce trajet (" + _toDisplayString(suggestedCities.value.length) + ") : ", 1),
                            _createElementVNode("div", _hoisted_24, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestedCities.value, (c) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: c.id,
                                  type: "button",
                                  class: _normalizeClass(["text-[11px] px-2 py-1 rounded border transition-colors disabled:opacity-40 disabled:cursor-not-allowed", usedCityIds.value.has(c.id)
											? 'bg-[#1e293b] border-[#374151] text-gray-500'
											: 'bg-[#1e3a8a] border-[#3b82f6] text-blue-100 hover:bg-[#1d4ed8]']),
                                  disabled: isSaving.value || usedCityIds.value.has(c.id),
                                  title: usedCityIds.value.has(c.id) ? 'Déjà ajouté' : `Ajouter ${c.label}`,
                                  onClick: ($event: any) => (addStopFromCity(c))
                                }, [
                                  _createTextVNode(_toDisplayString(c.label) + " ", 1),
                                  (usedCityIds.value.has(c.id))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, "✓"))
                                    : _createCommentVNode("", true)
                                ], 10, _hoisted_25))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_27, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cityPickerSearch).value = $event)),
                          type: "text",
                          placeholder: "Rechercher une autre ville…",
                          class: "text-sm px-2 py-1 rounded bg-[#1f2937] border border-[#374151] text-gray-100"
                        }, null, 512), [
                          [_vModelText, cityPickerSearch.value]
                        ]),
                        (filteredCities.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCities.value, (c) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: c.id,
                                  type: "button",
                                  class: "flex flex-row items-center justify-between text-xs px-2 py-1 rounded hover:bg-[#1e3a8a] text-left disabled:opacity-40 disabled:cursor-not-allowed",
                                  disabled: isSaving.value || usedCityIds.value.has(c.id),
                                  onClick: ($event: any) => (addStopFromCity(c))
                                }, [
                                  _createElementVNode("span", _hoisted_30, [
                                    _createTextVNode(_toDisplayString(c.label), 1),
                                    _createElementVNode("span", _hoisted_31, _toDisplayString(c.region ? `· ${c.region}` : ""), 1)
                                  ]),
                                  (usedCityIds.value.has(c.id))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, "✓ ajouté"))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_29))
                              }), 128))
                            ]))
                          : (cityPickerSearch.value && !isLoadingCities.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_33, " Aucune ville trouvée pour « " + _toDisplayString(cityPickerSearch.value) + " ». ", 1))
                            : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-[10px] text-gray-400 underline self-start mt-1",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (showManualForm.value = !showManualForm.value))
                      }, _toDisplayString(showManualForm.value ? "← Masquer la saisie manuelle" : "Saisie manuelle (ville hors référentiel)"), 1),
                      (showManualForm.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newStopForm.value.label) = $event)),
                              type: "text",
                              placeholder: "Libellé (ex : Carrefour de Foumbot)",
                              class: "text-sm px-2 py-1 rounded bg-[#1f2937] border border-[#374151] text-gray-100"
                            }, null, 512), [
                              [_vModelText, newStopForm.value.label]
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newStopForm.value.latitude) = $event)),
                                type: "number",
                                step: "0.0000001",
                                min: "-90",
                                max: "90",
                                placeholder: "Lat. (-90..90)",
                                class: "text-xs px-2 py-1 rounded bg-[#1f2937] border border-[#374151] text-gray-100"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  newStopForm.value.latitude,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newStopForm.value.longitude) = $event)),
                                type: "number",
                                step: "0.0000001",
                                min: "-180",
                                max: "180",
                                placeholder: "Long. (-180..180)",
                                class: "text-xs px-2 py-1 rounded bg-[#1f2937] border border-[#374151] text-gray-100"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  newStopForm.value.longitude,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newStopForm.value.estimated_minutes_from_origin) = $event)),
                              type: "number",
                              min: "0",
                              placeholder: "ETA depuis l'origine (min, optionnel)",
                              class: "text-xs px-2 py-1 rounded bg-[#1f2937] border border-[#374151] text-gray-100"
                            }, null, 512), [
                              [
                                _vModelText,
                                newStopForm.value.estimated_minutes_from_origin,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _createElementVNode("label", _hoisted_36, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newStopForm.value.is_terminus) = $event)),
                                type: "checkbox"
                              }, null, 512), [
                                [_vModelCheckbox, newStopForm.value.is_terminus]
                              ]),
                              _hoisted_37
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "self-start text-xs px-3 py-1 rounded bg-[#219152] hover:bg-[#167841] text-white disabled:opacity-40",
                              disabled: isSaving.value || !newStopForm.value.label,
                              onClick: addStop
                            }, " Ajouter l'arrêt manuel ", 8, _hoisted_38)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("p", _hoisted_40, " Tarifs segmentés (" + _toDisplayString(segments.value.length) + ") ", 1),
                    (isLoadingSegments.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, "Chargement…"))
                      : (segments.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, " Aucun tarif segmenté. Si vide, on retombe sur le tarif global du trajet (TicketRate) pour toutes les ventes. "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments.value, (seg) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: seg.uuid,
                                class: "flex flex-row items-center justify-between px-2 py-1 rounded bg-[#0f172a] border border-[#1e293b] text-sm"
                              }, [
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("span", _hoisted_45, _toDisplayString(getStopLabel(seg.from_stop_id)) + " → " + _toDisplayString(getStopLabel(seg.to_stop_id)), 1),
                                  _createElementVNode("span", _hoisted_46, _toDisplayString(_unref(useFormatMoney)(seg.cost)) + " FCFA ", 1)
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "text-xs text-red-400 hover:text-red-300 disabled:opacity-30 ml-2",
                                  disabled: isSaving.value,
                                  onClick: ($event: any) => (removeSegment(seg))
                                }, " × ", 8, _hoisted_47)
                              ]))
                            }), 128))
                          ])),
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _createVNode(_component_SelectTag, {
                        placeholder: "Arrêt de départ",
                        onModel: _cache[7] || (_cache[7] = (e) => newSegmentForm.value.from_stop_id = e.key),
                        selected: newSegmentForm.value.from_stop_id ?? 0,
                        data: JSON.stringify(stopOptions.value)
                      }, null, 8, ["selected", "data"]),
                      _createVNode(_component_SelectTag, {
                        placeholder: "Arrêt d'arrivée",
                        onModel: _cache[8] || (_cache[8] = (e) => newSegmentForm.value.to_stop_id = e.key),
                        selected: newSegmentForm.value.to_stop_id ?? 0,
                        data: JSON.stringify(stopOptions.value)
                      }, null, 8, ["selected", "data"]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newSegmentForm.value.cost) = $event)),
                        type: "number",
                        min: "0",
                        placeholder: "Prix en FCFA",
                        class: "text-sm px-2 py-1 rounded bg-[#1f2937] border border-[#374151] text-gray-100"
                      }, null, 512), [
                        [
                          _vModelText,
                          newSegmentForm.value.cost,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "self-start text-xs px-3 py-1 rounded bg-[#219152] hover:bg-[#167841] text-white disabled:opacity-40",
                        disabled: isSaving.value || !newSegmentForm.value.from_stop_id || !newSegmentForm.value.to_stop_id || newSegmentForm.value.cost == null,
                        onClick: addSegment
                      }, " Ajouter le tarif ", 8, _hoisted_50)
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_51, " Aucun trajet sélectionné. "))
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_component_ButtonTag, {
              label: "Fermer",
              activeIcon: false,
              css: "bg-gray-500 text-white px-6 py-2 hover:bg-gray-600 focus:outline-none",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('close')))
            })
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})